export const CREATE_PARTNER_FILE_STARTED = "CREATE_PARTNER_FILE_STARTED";
export const CREATE_PARTNER_FILE_SUCCEEDED = "CREATE_PARTNER_FILE_SUCCEEDED";
export const CREATE_PARTNER_FILE_FAILED = "CREATE_PARTNER_FILE_FAILED";
export const CREATE_PARTNER_FILE_REDIRECTED = "CREATE_PARTNER_FILE_REDIRECTED"

export const COMPUTE_PARTNER_FILE_NEXT_STATES_STARTED = "COMPUTE_PARTNER_FILE_NEXT_STATES_STARTED";
export const COMPUTE_PARTNER_FILE_NEXT_STATES_SUCCESS = "COMPUTE_PARTNER_FILE_NEXT_STATES_SUCCESS";
export const COMPUTE_PARTNER_FILE_NEXT_STATES_FAILED = "COMPUTE_PARTNER_FILE_NEXT_STATES_FAILED";

export const LOAD_PARTNER_FILES_SUCCESS = "LOAD_PARTNER_FILES_SUCCESS";
export const LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS = "LOAD_PARTNER_FILE_VISIBILITY_LEVELS_SUCCESS";

export const LOAD_PARTNER_FILE_USER_PREFERENCES_SUCCESS = "LOAD_PARTNER_FILE_USER_PREFERENCES_SUCCESS";
export const LOAD_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS = "LOAD_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS";
export const LOAD_PARTNER_FILE_DEFAULT_USER_PREFERENCE_SUCCESS = "LOAD_PARTNER_FILE_DEFAULT_USER_PREFERENCE_SUCCESS";

export const UPDATE_PARTNER_FILE_USER_PREFERENCES_SUCCESS = "UPDATE_PARTNER_FILE_USER_PREFERENCES_SUCCESS";
export const UPDATE_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS = "UPDATE_PARTNER_FILE_SELECTED_USER_PREFERENCE_SUCCESS";

export const LOAD_PARTNER_FILE_HEADER_STARTED = "LOAD_PARTNER_FILE_HEADER_STARTED";
export const LOAD_PARTNER_FILE_HEADER_SUCCESS = "LOAD_PARTNER_FILE_HEADER_SUCCESS";
export const LOAD_PARTNER_FILE_HEADER_FAILED = "LOAD_PARTNER_FILE_HEADER_FAILED";
export const PARTNER_FILE_HEADER_INVALIDATED = "PARTNER_FILE_HEADER_INVALIDATED";